import { makeStyles } from '@material-ui/core';
import { AIADMIN_PRIMARY_COLOR, AIADMIN_TEXT_SECONDARY } from './CommonThemes';

// eslint-disable-next-line no-unused-vars
const useHeaderStyles = (_props = {}) => {
  const useStyles = makeStyles({
    logo: {
      width: 115,
      height: 40,
      marginRight: '16px',
      cursor: 'pointer',
      marginLeft: '48px'
    },
    appBar: {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%'
    },
    headerSection: {
      padding: '0.5rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      color: 'secondary.light',
      boxShadow: 2,
      backgroundColor: AIADMIN_PRIMARY_COLOR,
      borderBottom: 'none'
    },
    flexAndCenter: {
      display: 'flex',
      alignItems: 'center'
    },
    tenantAbbreviation: {
      '&&': {
        color: AIADMIN_TEXT_SECONDARY,
        fontSize: `1.2rem`,
        fontWeight: 'bold',
        marginRight: `0.2rem`
      }
    }
  });

  return useStyles();
};

export default useHeaderStyles;
